<template>
  <!-- 我的工单 实际是 案例订单(case)的数据 -->
  <div class="order-bd">
    <div class="tab-content">
      <el-tabs v-model="billType">
        <el-tab-pane v-if="funcView.account_order_repair_list" name="repairOrder" :label="$t('order.wei_xiu_gong_dan')"></el-tab-pane>
        <el-tab-pane v-if="funcView.account_order_maintain_list" name="maintainOrder" :label="$t('order.bao_yang_gong_dan')"></el-tab-pane>
        <el-tab-pane v-if="funcView.account_order_replace_list" name="replaceRecord" :label="$t('order.ljghjl')"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="tab-container">
      <!-- 维修工单 -->
      <tab-repair-order v-if="billType === 'repairOrder'"></tab-repair-order>
      <!-- 保养工单 -->
      <tab-maintain-order v-if="billType === 'maintainOrder'"></tab-maintain-order>
      <!-- 零件更换记录 -->
      <tab-part-replace-record v-if="billType === 'replaceRecord'"></tab-part-replace-record>
    </div>
  </div>
</template>

<script>
import tabRepairOrder from './children/tab_repair_order.vue';
import tabMaintainOrder from './children/tab_maintain_order.vue';
import tabPartReplaceRecord from './children/tab_part_replace_record.vue';

export default {
  name: 'order',
  mixins: [],
  components: {
    tabRepairOrder,
    tabMaintainOrder,
    tabPartReplaceRecord,
  },
  computed: {},
  data() {
    return {
      billType: '',
      hasInit: false,
    };
  },

  mounted() {
    this.getFuncView(null, () => {
      const baseFuncView = this.funcView;
      const arr = [];
      if (baseFuncView.account_order_repair_list) {
        arr.push('repairOrder');
      }
      if (baseFuncView.account_order_maintain_list) {
        arr.push('maintainOrder');
      }
      if (baseFuncView.account_order_replace_list) {
        arr.push('replaceRecord');
      }
      if (arr.length) {
        this.billType = arr[0];
      }
    });
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.order-bd {
  padding: 24px;

  .tab-content {
    padding-left: 16px;
  }
}
</style>
